import { postForm } from '@/utils/http'

/**
 * 发送短信验证码
 * @param {Object} data
 * @param {string} data.mobile - 手机号
 * @param {string} data.event - register | resetpwd | changemobile | mobilelogin
 */
export function sendSms(data) {
  return postForm('/api/Sms/send', data)
}
